var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEditGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "nonzero",
    d: "M17.085 6.941c-.066-.073-.159-.115-.257-.117-.098-.003-.193.035-.263.105l-.277.276c-.07.07-.07.183 0 .253l.254.254c.034.034.08.053.127.053.048 0 .093-.02.127-.053l.27-.27c.137-.136.15-.358.02-.5z",
    transform: "translate(-638 -294) translate(98 221) translate(540 73.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23DF78",
    d: "M18.902 4.114l-7.844 7.828c-.047.048-.082.107-.1.171l-.363 1.08c-.017.06-.001.125.043.169.044.044.109.06.168.043l1.08-.363c.065-.018.124-.053.171-.1l7.83-7.843c.15-.153.15-.398 0-.55l-.432-.435c-.153-.152-.4-.152-.553 0z",
    transform: "translate(-638 -294) translate(98 221) translate(540 73.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#23DF78",
    d: "M16.665 9.88l-4.563 4.572c-.176.177-.393.308-.631.382l-.97.325c-.468.132-.972 0-1.316-.343-.344-.345-.475-.848-.343-1.317l.325-.97c.074-.237.204-.454.381-.63l4.572-4.564c.085-.086.111-.215.065-.326-.047-.112-.156-.185-.277-.185H6.096C4.94 6.824 4 7.762 4 8.92v8.984C4 19.06 4.939 20 6.096 20h8.984c1.158 0 2.096-.939 2.096-2.096v-7.812c0-.121-.073-.23-.185-.277-.111-.046-.24-.02-.326.065z",
    transform: "translate(-638 -294) translate(98 221) translate(540 73.5)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditGreen);
export default __webpack_public_path__ + "static/media/ic-edit-green.c21051052c62f61ef9f88b421e9f205a.svg";
export { ForwardRef as ReactComponent };